import React, { useEffect, useState } from 'react';

/**
 * Top-of-page banner shown only on the staging environment.
 *
 * Detection: client checks REACT_APP_ENVIRONMENT (baked at build time) first,
 * then falls back to a single HEAD /api/health request to read the
 * X-Environment response header the server sets when NODE_ENV=staging.
 *
 * Render: 32px-tall amber bar, fixed top. Doesn't push content (z-index over
 * the storefront chrome) but the chrome already accounts for a top offset on
 * mobile, so this overlap is acceptable for a trial env.
 */
export default function StagingBanner() {
  const [show, setShow] = useState(
    () => (process.env.REACT_APP_ENVIRONMENT || '').toLowerCase() === 'staging'
  );

  useEffect(() => {
    if (show) return;
    let cancelled = false;
    fetch('/api/health', { method: 'HEAD' })
      .then((r) => {
        if (cancelled) return;
        if ((r.headers.get('x-environment') || '').toLowerCase() === 'staging') {
          setShow(true);
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [show]);

  if (!show) return null;
  return (
    <div
      role="status"
      aria-label="Staging environment notice"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        background: '#b45309',
        color: '#fff',
        fontSize: 13,
        fontWeight: 600,
        textAlign: 'center',
        padding: '6px 12px',
        letterSpacing: 0.3,
      }}
    >
      STAGING — trial environment. Data, payments, and emails are sandboxed.
    </div>
  );
}
